import React from 'react';

interface ConsolidateIconProps extends React.SVGProps<SVGSVGElement> {
	width?: number;
	height?: number;
	fill?: string;
}

export function ConsolidateIcon({
	width = 24,
	height = 24,
	fill = 'currentColor',
	...props
}: Readonly<ConsolidateIconProps>): JSX.Element {
	return (
		<svg
			{...props}
			fill="none"
			width={width}
			height={height}
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M19.2727 10.36H17.7273V5.04C17.7273 3.36088 16.425 2 14.8182 2H9.18182C7.575 2 6.27273 3.36088 6.27273 5.04V10.36H4.72727C4.325 10.36 4 10.6996 4 11.12V20.24C4 20.6604 4.325 21 4.72727 21H19.2727C19.675 21 20 20.6604 20 20.24V11.12C20 10.6996 19.675 10.36 19.2727 10.36ZM7.90909 5.04C7.90909 4.30613 8.47955 3.71 9.18182 3.71H14.8182C15.5205 3.71 16.0909 4.30613 16.0909 5.04V10.36H7.90909V5.04ZM18.3636 19.29H5.63636V12.07H18.3636V19.29ZM11.3636 15.9888V17.2475C11.3636 17.352 11.4455 17.4375 11.5455 17.4375H12.4545C12.5545 17.4375 12.6364 17.352 12.6364 17.2475V15.9888C12.824 15.848 12.964 15.6487 13.0363 15.4195C13.1086 15.1902 13.1094 14.943 13.0387 14.7132C12.9679 14.4835 12.8292 14.2831 12.6426 14.141C12.4559 13.9989 12.231 13.9223 12 13.9223C11.769 13.9223 11.5441 13.9989 11.3574 14.141C11.1707 14.2831 11.0321 14.4835 10.9613 14.7132C10.8906 14.943 10.8914 15.1902 10.9637 15.4195C11.036 15.6487 11.176 15.848 11.3636 15.9888Z"
				fill={fill}
			/>
		</svg>
	);
}
